import QuestionViewVerbal from "./QuestionViewVerbal";
import QuestionModel from "../../maths/QuestionModel";

export default class QuestionViewSort extends QuestionViewVerbal {
    constructor(question) {
        super(question);

        this._inputField.visible = false;
    }

    filterTemplate(x) {
        switch (this._question.type) {
            case QuestionModel.TYPE_COVERSION_SORT: {
                if(x.type.constructor === Array){
                    for (const typeElement of x.type) {
                        if((typeElement === this.question.unitType || typeElement === 'any') && x.ascending === this._question.ascending)
                            return true;
                    }
                    return false
                }else
                    return ((x.type === this.question.unitType || x.type === 'any') && x.ascending === this._question.ascending);
            }
            default:{return x.ascending === this._question.ascending;}
        }
    }

    onConfirmButtonClick(button) {
        this._confirmButton.enabled = false;
        this.signals.confirm.dispatch(this, this.isCorrect());
    }

    isCorrect() {
        for (let i = 0; i < this._question.values.length; ++i) {
            const a = this._question.values[i];
            const b = this._question.sort[i];
            if (a !== b) return false;
        }
        return true;
    }
}